import React from 'react';

const LoadingOverlay = ({ message }) => {
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 z-50 flex items-center justify-center backdrop-blur-sm">
      <div className="p-8 flex flex-col items-center max-w-sm mx-4">
        {/* Loading text */}
        <p className="text-white text-center font-medium">
          {message || 'Chargement...'}
        </p>
        
        {/* Progress bar */}
        <div className="w-full mt-4 h-1 bg-gray-800/30 rounded-full overflow-hidden">
          <div className="w-full h-full bg-gradient-to-r from-blue-600 to-teal-500 animate-loading-progress"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay; 